/*
 * Description: 与SDK通信接口
 * Date: 2019-09-19 10:35:31
 * Author: yaoshun
 * LastEditTime: 2019-09-19 17:45:24
 */
import jsBridge from '../common/jsBridge'
import {_device} from "../common/m_base/util";

/**
 * @api {get} customCommand 自定义命令, 仅用于大模板 demo 页 SDK API 调试, 请不要在生产环境模板中使用
 * @apiName 自定义命令
 * @apiGroup 杂项
 * @apiParam fnName SDK API 指令 path
 * @apiParam params 调用时的入参
 * @return {*|Promise<any>} 返回调用 SDK API 成功时的数据
 */
export function customCommand({fnName, params}) {
    return jsBridge.callNative({fnName, params})
}

/**
 * RewardJs/getEndScreenInfo
 * @param params
 * @returns {*|Promise<any>}
 */
export function RewardJsGetEndScreenInfo(params = {pageNo: 1, exclude_ids: []}) {
    return jsBridge.callNative({fnName: 'RewardJs/getEndScreenInfo', params})
}

// rewardjs 安装调用
export function RewardJsInstall(campaign) {
    return jsBridge.callNative({fnName: 'RewardJs/install', params: campaign})
}

// 显示 native 关闭按钮
export function RewardJsToggleCloseBtnShow(params = {state: 1}) {
    return jsBridge.callNative({fnName: 'RewardJs/toggleCloseBtn', params})
}

// 隐藏 native 关闭按钮
export function RewardJsToggleCloseBtnHide(params = {state: 2}) {
    return jsBridge.callNative({fnName: 'RewardJs/toggleCloseBtn', params})
}

// 从 SDK 获取上下文环境数据
export function VideoBridgeInit(params = {pageNo: 1, exclude_ids: []}) {
    return jsBridge.callNative({fnName: 'VideoBridge/init', params})
}

/**
 * js 通知SDK发送用具体UA上报url
 * @param {Object} params
 * @param {Number} params.type campaign.onlyImpressionUrl,
 * @param {String} params.url campaign.impressionUA
 */
export function VideoBridgeReportUrl(params = {type: 1, url: ''}) {
    return jsBridge.callNative({fnName: 'VideoBridge/reportUrl', params})
}

/**
 * js通知SDK 在客户端发出请求,iOS SDK从v5.6.0 Banner版本开始支持，所有广告类型都支持
 *  数组元素:  {"url":"www.mintegral.com", "type":2}
 *  要求SDK 以type类型的uaType来请求改url
 * type 为可选，目前Impression 一定有，其他的不一定有
 */
export function VideoBridgeReportUrls(params = [{type: 1, url: ''}, {type: 1, url: ''}]) {
    return jsBridge.callNative({fnName: 'VideoBridge/reportUrls', params})
}

/**
 * 显示并设置原生视频位置
 * @param params
 * @returns {*|Promise<any>}
 * @constructor
 */
export function VideoBridgeShowVideoLocation(params = {}) {
    return jsBridge.callNative({fnName: 'VideoBridge/showVideoLocation', params})
}

/**
 * 播放视频
 * @returns {*|Promise<any>}
 * @constructor
 */
export function VideoBridgeVideoOperatePlay() {
    return jsBridge.callNative({fnName: 'VideoBridge/VideoOperate', params: {"pause_or_resume": 1}})
}

/**
 * 暂停播放视频
 * @returns {*|Promise<any>}
 * @constructor
 */
export function VideoBridgeVideoOperatePause() {
    return jsBridge.callNative({fnName: 'VideoBridge/VideoOperate', params: {"pause_or_resume": 2}})
}

// load 阶段通知 SDK "H5 页面已经 ready", 可以展示(show) 了
export function VideoBridgeReadyStatusHasReady(params = {isReady: 1}) {
    return jsBridge.callNative({fnName: 'VideoBridge/readyStatus', params})
}

// load 阶段通知 SDK "H5 页面没有 ready"
export function VideoBridgeReadyStatusNotReady({errMessage, errDetail} = {}) {
    console.error({errMessage, errDetail})
    return false
    let params = Object.assign({errMessage, errDetail}, {isReady: 2})
    return jsBridge.callNative({fnName: 'VideoBridge/readyStatus', params})
}

// iOS 下禁用页面滑动反弹
export function VideoBridgeToggleBouncesOff(params = {state: 0}) {
    if (_device().isiOS) {
        return jsBridge.callNative({fnName: 'VideoBridge/toggleBounces', params})
    }
}

// iOS 下启用页面滑动反弹
export function VideoBridgeToggleBouncesOn(params = {state: 1}) {
    if (_device().isiOS) {
        return jsBridge.callNative({fnName: 'VideoBridge/toggleBounces', params})
    }
}

/**
 * 向 SDK 询问 1 ~ n 个广告素材下载/解压到本地之后的存储地址 (file: 协议)
 * @param {String} unitId - 广告位 id
 * @param {Object[]} resource - 要获取的资源描述列表
 * @param {Number} resource[].type - 资源的类型（1:视频，2:web素材地址）
 * @param {String} resource[].ref - 下发的文件远程地址 或者其他可以唯一标示本地资源的索引
 * @returns {*|Promise<any>} 资源在本地存储的路径 (file: 协议)
 */
export function VideoBridgeGetFileInfo({unitId, resource}) {
    let params = {
        unitId,
        resource,
    }
    return jsBridge.callNative({fnName: 'VideoBridge/getFileInfo', params})
}

/**
 * 自定义广播
 * @param unitId
 * @param eventName
 * @param data
 * @returns {Promise<any>}
 */
export function broadcast({unitId = null, eventName = null, data = {}}) {
    if (unitId !== null && eventName !== null) {
        let params = {unitId, eventName, data}
        return jsBridge.callNative({fnName: 'VideoBridge/broadcast', params})
    } else {
        let errMsg = '当前的 unitId 或要广播的事件名为空, 已拒绝, 请检查后重试';
        console.error({errMsg, unitId, eventName, data})
    }
}

export function broadcastWebviewshow({unitId, data}) {
    let eventName = 'broadcastwebviewshow'
    return broadcast({unitId, eventName, data})
}

export function broadcastNeedBTContext({unitId, data}) {
    let eventName = 'needbtcontext'
    return broadcast({unitId, eventName, data})
}

export function broadcastSendBTContext({unitId, data}) {
    let eventName = 'sendbtcontext'
    return broadcast({unitId, eventName, data})
}

//------------------------------ 原生事件监听 ------------------------------//

export function onBroadcast({cb}) {
    document.addEventListener('broadcast', res => {
        typeof cb === 'function' && cb(res)
    })
}

export function onBroadcastCustom({cb}) {
    let eventName = 'broadcastcustom'
    document.addEventListener('broadcast', res => {
        if (res && res.param && res.param.eventName === eventName) typeof cb === 'function' && cb(res)
    })
}

export function onBroadcastHideCtaBanner({cb}) {
    let eventName = 'broadcastctabannerclosemini'
    document.addEventListener('broadcast', res => {
        if (res && res.param && res.param.eventName === eventName) typeof cb === 'function' && cb(res)
    })
}

export function onBroadcastWebviewshow({cb}) {
    let eventName = 'broadcastwebviewshow'
    document.addEventListener('broadcast', res => {
        if (res && res.param && res.param.eventName === eventName) typeof cb === 'function' && cb(res)
    })
}

export function onBroadcastNeedBTContext({cb}) {
    let eventName = 'needbtcontext'
    document.addEventListener('broadcast', res => {
        if (res && res.param && res.param.eventName === eventName) typeof cb === 'function' && cb(res)
    })
}

export function onBroadcastSendBTContext({cb}) {
    let eventName = 'sendbtcontext'
    document.addEventListener('broadcast', res => {
        if (res && res.param && res.param.eventName === eventName) typeof cb === 'function' && cb(res)
    })
}

/**
 * 暂停页面，切换出`app`
 * @param cb
 */
export function onSystemPause(cb) {
    jsBridge.addEventListener('onSystemPause', function (res) {
        console.log('onSystemPause res: ', res.param)
        cb(res)
    }, false)
}

/**
 * 唤醒`app`
 * @param cb
 */
export function onSystemResume(cb) {
    jsBridge.addEventListener('onSystemResume', function (res) {
        console.log('onSystemResume res: ', res.param)
        cb(res)
    }, false)
}

/**
 * 销毁当前页面 不能有回调
 * @param cb
 */
export function onSystemDestory(cb) {
    jsBridge.addEventListener('onSystemDestory', function (res) {
        console.log('onSystemDestory res: ', res.param)
        cb(res.param)
    }, false)
}

/**
 * 视频状态通知监听
 * @param cb
 */
export function onVideoStatusNotify(cb) {
    jsBridge.addEventListener('onVideoStatusNotify', function (res) {
        cb(res.param)
    }, false)
}

/**
 * `sdk`通知`js`点击事件
 * @param cb
 */
export function onJSClick(cb) {
    jsBridge.addEventListener('onJSClick', function (res) {
        console.log('onJSClick res: ', res.param)
        cb(res.param)
    }, false)
}

/**
 * 监听横竖屏旋转
 * @param cb
 * portrait 竖屏，landscape 横屏
 */
export function orientation(cb) {
    jsBridge.addEventListener('orientation', function (res) {
        console.log('orientation res: ', res.param)
        cb(res)
    }, false)
}

/**
 * 监听横竖屏旋转
 * @param cb
 * portrait 竖屏，landscape 横屏
 */
export function onWebviewshow(cb) {
    jsBridge.addEventListener('webviewshow', function (res) {
        console.log('webviewshow res: ', res)
        cb(res)
    }, false)
}

/**
 * 监听安卓的`回退`按钮
 * @param cb
 */
export function onSystemBackPressed(cb) {
    jsBridge.addEventListener('onSystemBackPressed', function (res) {
        cb && cb(res.param)
    }, false)
}

/**
 * onJSBridgeConnect
 * @param cb
 */
export function onJSBridgeConnected(cb) {
    jsBridge.addEventListener('onJSBridgeConnected', function (res) {
        cb(res)
    }, false)
}

/**
 * IOS 主动通知 屏幕宽高和方向
 * @param cb
 */
export function showDataInfo(cb) {
    jsBridge.addEventListener('showDataInfo', function (res) {
        cb(res.param)
    }, false)
}

// 单 offer 事件
/**
 * ios 展示 storekit 成功或者失败
 * @param cb
 */
export function storeKitShowSuccess(cb) {
    jsBridge.addEventListener('storeKitShowSuccess', function (res) {
        cb(res.param)
    }, false)
}

/**
 * 播放进度通知状态,progress表示当前进度如0.20,time表示当前播放时长单位秒,duration表示总时长
 * @param cb
 */
export function onVideoProgressNotify(cb) {
    jsBridge.addEventListener('onVideoProgressNotify', function (res) {
        cb(res.param)
    }, false)
}